import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  checkAlreadyAnswer,
  checkAlreadyAnswerClear,
  getHomeBanner,
  getHomeCourse,
  getQuestionOfTheDay,
} from "../../redux/home/actions";
import { clearTestInfo } from "../../redux/test/actions";

const useHome = () => {
  const banners = useSelector((state) => state.home.banners.data);
  const courses = useSelector((state) => state.home.courses.data);
  const user = useSelector((state) => state.auth.user.data);
  const qodAnswer = useSelector((state) => state.home.qodAnswer.data);
  const questionOfDaySuccess = useSelector(
    (state) => state.home.questionOfDay.success
  );

  const dispatch = useDispatch();

  const closeModal = () => {
    dispatch(checkAlreadyAnswerClear());
  };

  useEffect(() => {
    if (!banners?.length && user?.objectId) {
      dispatch(getHomeBanner());
      dispatch(getHomeCourse(user?.objectId));
      if (!qodAnswer) dispatch(checkAlreadyAnswer(user.objectId));
    }
    dispatch(clearTestInfo());
  }, [user]);

  useEffect(() => {
    if (qodAnswer) {
      dispatch(getQuestionOfTheDay());
    } else {
      dispatch(checkAlreadyAnswerClear());
    }
  }, [qodAnswer]);

  return { banners, courses, questionOfDaySuccess, closeModal };
};

export default useHome;
